var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('b-badge',{staticClass:"sr-status-badge",style:(_vm.style),attrs:{"pill":""}},[_vm._v("\n  "+_vm._s(_vm.$tc(_vm.text))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }